/**
 * @author PengWen
 * @description zoneCode管理页面配置
 * @Date 2022/10/21
 */
import React from 'react'
import {component_tool, framework_tool ,utils_tool} from '../../../tool';
let {WizModal} = component_tool;
let { $$ } = utils_tool;

//配置项
let componentName = 'OrganizationZoneCode'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "orgId",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    searchItem: {},
    tableItem: {
      width: 300
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入组织名称'
      }]
    },
  },
  {
    title: "组织编码",
    name: "orgCode",
    searchItem: {},
    tableItem: {
      width: 200
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入组织编码'
      }]
    }
  },
  {
    title: "zoneCode值",
    name: "zoneCode",
    searchItem: {},
    tableItem: {
      width: 200,
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入zoneCode值'
      }]
    }
  },
  {
    title: "数据来源",
    name: "dataSource",
    tableItem: {
      width: 200,
    },
    searchItem: {
      type: "select",
    },
    dict: [
      {code: 1, codeName: '管理端'},
      {code: 0, codeName: '第三方推送'}
    ],
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    searchItem: {
      type: "select",
    },
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'}
    ],
    formItem: {
      initialValue: 1,
      type: 'radio'
    }
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps:{
        buttonSort: ['add','delete','export'],
        collapse: false,
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增zoneCode关系', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/org/zoneCode/zoneCodeAdd'
              }
            }
          },
          {
            key: "delete",
            custom: true,
            needSelect: true,
            params: {icon: "delete", children: "删除", type: "danger"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                const content = '删除后数据不可恢复，您确定要删除选中的内容吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']){
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length>0){
                rows.forEach(item => {
                  let {dataSource} =item;
                  if (dataSource != null && dataSource != 1){
                    disabled = 1;
                  }
                })
              }else {
                disabled = 1;
              }
              return { disabled: disabled }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams:(rows,record,filters,callback)=>{
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['update','enableOrDisable'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/org/zoneCode/zoneCodeUpd"
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.dataSource === 1) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: { '1': '禁用', '0': '启用', }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
                }该组织的zoneCode关系吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.dataSource === 1) {
              result.disabled = false
            }
            return result
          },
        },
      ],
      rowOperateProps: {
        width: 120,
        fixed: 'right',
      },
      commonOperate: {
        add: true,
        delete: true,
        edit: true
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
 